import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import SystemHelper, { SystemConstants } from 'features/System/systemHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogUpdateEnergyBillView from '../DialogUpdateEnergyBillView';
import useAppConfig from 'hooks/useAppConfig';

EnergyBillInvoiceDetailView.propTypes = {
  stationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  month: PropTypes.string,
};

function EnergyBillInvoiceDetailView({ billId, stationId, month }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const appConfig = useAppConfig();
  const { user } = useSelector((state) => state.auth);
  const isAdmin =
    user?.role === ChargeConstants.UserRole.ADMIN ||
    user?.role === ChargeConstants.UserRole.OPERATOR;
  const isAgency = user?.role === ChargeConstants.UserRole.AGENCY;
  const isInvestor =
    isAgency &&
    (user?.agency?.primaryRole === AgencyConstants.AgencyRole.INVESTOR ||
      AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.INVESTOR));
  const isLandlord =
    isAgency &&
    (user?.agency?.primaryRole === AgencyConstants.AgencyRole.LANDLORD ||
      AgencyHelper.Utils.checkRole(user?.agency, AgencyConstants.AgencyRole.LANDLORD));
  const [billDetail, setBillDetail] = useState();
  useEffect(() => {
    handleRefresh();
  }, [stationId]);

  // MARK: ---- METHODS ----
  const handleRefresh = () => {
    if (Utils.isValid(stationId)) {
      SystemHelper.API.EnergyBill.requestGetAll({
        stationId: stationId,
        month: month,
      }).then((response) => {
        const energyBillList = response.energyBills;
        setBillDetail(energyBillList?.[0]);
      });
    }
  };

  const buildMoreActions = (row) => {
    const actions = [];
    // cap nhat hoa don
    // if ((isAdmin || isInvestor) && row?.status === SystemConstants.EnergyBillStatus.MISSING) {
    //   actions.push({
    //     text: 'Cập nhật hoá đơn',
    //     iconElement: <i className="fa-regular fa-file-invoice" style={{ fontSize: '1.1rem' }} />,
    //     click: () => {
    //       AppCustomDialogHelper.show(
    //         `Cập nhật hoá đơn tiền điện [${row?.evnCustomerId}]`,
    //         <DialogUpdateEnergyBillView
    //           item={row}
    //           onCancel={() => {
    //             AppCustomDialogHelper.hide();
    //           }}
    //           onDone={() => {
    //             AppCustomDialogHelper.hide();
    //             handleRefresh();
    //           }}
    //         />,
    //         'lg',
    //         false,
    //         true
    //       );
    //     },
    //   });
    // }
    // chinh sua hoa don
    if (
      (isAdmin || isInvestor || isLandlord) &&
      [
        SystemConstants.EnergyBillStatus.VALIDATED,
        SystemConstants.EnergyBillStatus.REJECTED,
        SystemConstants.EnergyBillStatus.PENDING,
      ].includes(row?.status)
    ) {
      actions.push({
        text: 'Chỉnh sửa hoá đơn',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          AppCustomDialogHelper.show(
            `Cập nhật hoá đơn tiền điện [${row?.evnCustomerId}]`,
            <DialogUpdateEnergyBillView
              item={row}
              onCancel={() => {
                AppCustomDialogHelper.hide();
              }}
              onDone={() => {
                AppCustomDialogHelper.hide();
                handleRefresh();
              }}
            />,
            'lg',
            false,
            true
          );
        },
      });
    }
    // gui phan hoi
    if (
      (isInvestor || isLandlord) &&
      [
        SystemConstants.EnergyBillStatus.REJECTED,
        SystemConstants.EnergyBillStatus.PENDING,
        SystemConstants.EnergyBillStatus.MISSING,
      ].includes(row?.status)
    ) {
      actions.push({
        text: 'Gửi phản hồi',
        iconElement: (
          <i className="fa-regular fa-message-exclamation" style={{ fontSize: '1.1rem' }} />
        ),
        click: () => {
          SystemHelper.UI.EnergyBill.showDialogConfirmFeedback(row, () => {
            handleRefresh();
          });
        },
      });
    }
    // xac nhan hop le
    if (isAdmin && row?.status === SystemConstants.EnergyBillStatus.PENDING) {
      actions.push({
        text: 'Xác nhận hợp lệ',
        iconElement: <i className="fa-regular fa-check-circle" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          SystemHelper.UI.EnergyBill.showDialogConfirmValidate(row, () => {
            handleRefresh();
          });
        },
      });
    }
    // xac nhan khong hop le
    if (isAdmin && row?.status === SystemConstants.EnergyBillStatus.PENDING) {
      actions.push({
        text: 'Xác nhận không hợp lệ',
        iconElement: <i className="fa-regular fa-times-circle" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          SystemHelper.UI.EnergyBill.showDialogConfirmReject(row, () => {
            handleRefresh();
          });
        },
      });
    }
    // xem phan hoi
    if (isAdmin) {
      actions.push({
        text: 'Xem phản hồi',
        iconElement: (
          <i className="fa-regular fa-messages-question" style={{ fontSize: '1.1rem' }} />
        ),
        click: () => {
          SystemHelper.UI.EnergyBill.showDialogViewFeedback(row);
        },
      });
    }
    // xem ly do khong hop le
    if ((isInvestor || isLandlord) && row?.status === SystemConstants.EnergyBillStatus.REJECTED) {
      actions.push({
        text: 'Xem lý do không hợp lệ',
        iconElement: (
          <i className="fa-regular fa-messages-question" style={{ fontSize: '1.1rem' }} />
        ),
        click: () => {
          SystemHelper.UI.EnergyBill.showDialogViewRejectReason(row);
        },
      });
    }
    return actions;
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div>
          {/* header */}
          <div
            className="d-flex align-items-center justify-content-between px-4 py-3"
            style={{
              borderBottom: `1px dashed ${AppColors.gray[300]}`,
            }}
          >
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center gap-2">
                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                  {billDetail?.evnCustomerId}
                </span>
                <KTLabel
                  text={SystemHelper.Utils.EnergyBill.getEnergyBillStatusName(billDetail?.status)}
                  isInline={true}
                  size={KTLabelSize.medium}
                  additionalClassName={`label-light-${SystemHelper.Utils.EnergyBill.getEnergyBillStatusColor(
                    billDetail?.status
                  )}`}
                />
              </div>
              <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                Trạm sạc:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                  {billDetail?.station?.name}
                </span>
              </span>
            </div>
            <div className='d-flex gap-2'>
              {billDetail?.status === SystemConstants.EnergyBillStatus.MISSING ? (
                <div>
                  {UIHelper.buildGreenButton(
                    'Cập nhật hoá đơn',
                    () => {
                      AppCustomDialogHelper.show(
                        `Cập nhật hoá đơn tiền điện [${billDetail?.evnCustomerId}]`,
                        <DialogUpdateEnergyBillView
                          item={billDetail}
                          onCancel={() => {
                            AppCustomDialogHelper.hide();
                          }}
                          onDone={() => {
                            AppCustomDialogHelper.hide();
                            handleRefresh();
                          }}
                        />,
                        'lg',
                        false,
                        true
                      );
                    },
                    <i className="fa-regular fa-file-invoice" />
                  )}
                </div>
              ) : (
                <></>
              )}
              <div>
                {UIHelper.buildMoreActionsButton(buildMoreActions(billDetail), false)}
              </div>
            </div>
          </div>

          {/* content */}
          <div className="row m-0 p-0 px-2 mt-2">
            {/* thong tin hoa don */}
            <div className="col-lg-6 mb-4 px-2">
              <div className="d-flex flex-column gap-2">
                {UIHelper.buildSectionTitle('Thông tin hoá đơn')}
                {UIHelper.buildSectionCard(
                  <div>
                    {UIHelper.buildCardCellItem(
                      'Mã tài khoản điện lực',
                      billDetail?.evnCustomerId ?? ''
                    )}
                    {UIHelper.buildCardCellItem(
                      'Điện năng tiêu thụ',
                      (Utils.isValid(billDetail?.evnEnergyUsed)
                        ? Utils.formatNumber(billDetail?.evnEnergyUsed)
                        : '') + ' kWh'
                    )}
                    {UIHelper.buildCardCellItem(
                      'HĐ tiền điện (trước thuế)',
                      (Utils.isValid(billDetail?.amountBeforeTax)
                        ? Utils.formatNumber(billDetail?.amountBeforeTax)
                        : '') + ' VNĐ'
                    )}
                    {UIHelper.buildCardCellItem(
                      'Thuế suất',
                      (Utils.isValid(billDetail?.taxRate)
                        ? Utils.formatNumber(billDetail?.taxRate * 100)
                        : '') + '%'
                    )}
                    {UIHelper.buildCardCellItem(
                      'HĐ tiền điện (sau thuế)',
                      (Utils.isValid(billDetail?.amountBeforeTax)
                        ? Utils.isValid(billDetail?.taxRate)
                          ? Utils.formatNumber(
                            billDetail?.amountBeforeTax * (1 + billDetail?.taxRate)
                          )
                          : Utils.formatNumber(billDetail?.amountBeforeTax)
                        : '') + ' VNĐ'
                    )}
                    {UIHelper.buildCardCellItem(
                      'Ngày gửi hóa đơn',
                      Utils.formatDateTimeToString(billDetail?.updatedAt, 'DD/MM/YYYY - HH:mm')
                    )}
                    {UIHelper.buildCardCellItem(
                      'Hóa đơn từ điện lực',
                      'Xem chi tiết',
                      () => {
                        if (Utils.isValid(billDetail?.evnInvoiceDocument))
                          Utils.openInNewTab(Utils.getFullUrl(billDetail?.evnInvoiceDocument));
                      },
                      false
                    )}
                  </div>
                )}
              </div>
            </div>
            {/* thong tin tram sac */}
            <div className="col-lg-6 mb-4 px-2">
              <div className="d-flex flex-column gap-2">
                {UIHelper.buildSectionTitle('Thông tin trạm sạc')}
                {UIHelper.buildSectionCard(
                  <div>
                    {UIHelper.buildCardCellItem('Mã trạm sạc', billDetail?.station?.stationCode)}
                    {UIHelper.buildCardCellItem('Tên trạm sạc', billDetail?.station?.name, () => {
                      Utils.openInNewTab(
                        `${AppRoute.stationList}/${billDetail?.station?.stationId}`
                      );
                    })}
                    {UIHelper.buildCardCellItem(
                      'Đối tượng quản lý trạm sạc',
                      Utils.isValid(billDetail?.station?.agencyId)
                        ? Utils.isValid(billDetail?.station?.landlordId)
                          ? 'Dự án HTKD'
                          : billDetail?.station?.agencyId === appConfig?.groupAgencyId
                            ? 'Dự án HTKD'
                            : 'NĐT nhượng quyền'
                        : 'Nhà điều hành'
                    )}
                    {UIHelper.buildCardCellItem(
                      'NĐT/Chủ mặt bằng',
                      Utils.isValid(billDetail?.station?.investor)
                        ? billDetail?.station?.investor?.name
                        : Utils.isValid(billDetail?.station?.landlord)
                          ? billDetail?.station?.landlord?.name
                          : '',
                      () => {
                        if (Utils.isValid(billDetail?.station?.investor)) {
                          Utils.openInNewTab(
                            `/investor/${billDetail?.station?.investor?.agencyId}`
                          );
                        } else if (Utils.isValid(billDetail?.station?.landlord)) {
                          Utils.openInNewTab(
                            `/landlord/${billDetail?.station?.landlord?.agencyId}`
                          );
                        }
                      },
                      false
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EnergyBillInvoiceDetailView;
